module.exports = __webpack_public_path__ + "static/media/20_000005.8cb9127b.jpg";